import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "transaction-confirm-card" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "token-box-group" }
const _hoisted_4 = { class: "token-box" }
const _hoisted_5 = { class: "token-box-value" }
const _hoisted_6 = { class: "token-box-symbol token-name" }
const _hoisted_7 = { class: "token-box" }
const _hoisted_8 = { class: "token-box-value" }
const _hoisted_9 = { class: "token-box-symbol token-name" }
const _hoisted_10 = { class: "middle-arrow" }
const _hoisted_11 = { class: "arrow-icon" }
const _hoisted_12 = { class: "estimated-text" }
const _hoisted_13 = { class: "order-details-title" }
const _hoisted_14 = { class: "details-list" }
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "buttons-row" }
const _hoisted_17 = ["textContent"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]

import { storeToRefs } from "pinia";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";
import TransactionConfirmDetailRow from "@/components/Dialogs/TransactionConfirmDetailRow.vue";
import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";
import { AETERNITY_SYMBOL } from "@/utils/constants";
import { formatFractionalPrice } from "@/utils/common";
import { computed } from "vue";
import { Decimal } from "@/libs/decimal";
import { useCurrencies } from "@/composables";
import { useTokenTradeStore } from "@/stores/tokenTradeStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'TradeTransactionConfirm',
  setup(__props) {

const {
  tokenA,
  tokenB,
  token,
  activeTradeView,
  isSelling,
  isBuying,
  isAllowSelling,
  priceImpactDiff,
  estimatedNextTokenPriceImpactDifferenceFormattedPercentage,
  desiredSlippage,
} = storeToRefs(useTokenTradeStore());

const { modalData } = storeToRefs(useTransactionConfirmModal());

const { getFiat, currentCurrencyInfo } = useCurrencies();

const amountInAE = computed(() =>
  isBuying.value
    ? Decimal.from(tokenA.value || 0)
    : Decimal.from(tokenB.value || 0)
);
const formattedAmountInAE = computed(() =>
  formatFractionalPrice(amountInAE.value)
);
const formattedAmountInUSD = computed(() =>
  formatFractionalPrice(getFiat(amountInAE.value))
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("dialogs.transactionConfirm.title", {
            action: _ctx.$t(`common.${_unref(activeTradeView)}`),
          })), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(FractionFormatter, {
                "fractional-price": 
                _unref(formatFractionalPrice)(_unref(Decimal).from(_unref(tokenA) ?? 0))
              
              }, null, 8, ["fractional-price"])
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(isBuying) ? _unref(AETERNITY_SYMBOL) : _unref(token)?.symbol), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(FractionFormatter, {
                "fractional-price": 
                _unref(formatFractionalPrice)(_unref(Decimal).from(_unref(tokenB) ?? 0))
              
              }, null, 8, ["fractional-price"])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(isBuying) ? _unref(token)?.symbol : _unref(AETERNITY_SYMBOL)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_v_icon, { size: "x-small" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-arrow-down")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("dialogs.transactionConfirm.estimatedOutput", {
            amount: _unref(modalData).minReceived,
            symbol: _unref(modalData).tokenSymbol,
          })), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("common.orderDetails")), 1),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(TransactionConfirmDetailRow, {
            label: _ctx.$t('dialogs.transactionConfirm.amountInAE')
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createTextVNode(" ~")),
              _createVNode(FractionFormatter, { "fractional-price": formattedAmountInAE.value }, null, 8, ["fractional-price"]),
              _createTextVNode(" " + _toDisplayString(_unref(AETERNITY_SYMBOL)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(TransactionConfirmDetailRow, {
            label: 
            _ctx.$t('dialogs.transactionConfirm.amountInCurrency', {
              currency: _unref(currentCurrencyInfo).code,
            })
          
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(currentCurrencyInfo).symbol) + " ", 1),
              _createVNode(FractionFormatter, { "fractional-price": formattedAmountInUSD.value }, null, 8, ["fractional-price"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(TransactionConfirmDetailRow, { label: "Allowed Slippage" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(Number(_unref(desiredSlippage) ?? 0).toFixed(2)) + "% ", 1)
            ]),
            _: 1
          }),
          _createVNode(TransactionConfirmDetailRow, { label: "Price Impact" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([
              _unref(isBuying) ? 'text-green' : 'text-red',
              'd-flex align-center ga-1',
            ])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(isBuying) ? "+" : "-"), 1),
                  _createVNode(FractionFormatter, {
                    "fractional-price": _unref(formatFractionalPrice)(_unref(priceImpactDiff))
                  }, null, 8, ["fractional-price"]),
                  _createTextVNode(" " + _toDisplayString(_unref(AETERNITY_SYMBOL)), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(['impact-badge', _unref(isBuying) ? 'bg-green' : 'bg-red'])
                }, _toDisplayString(_unref(isBuying) ? "+" : "-") + _toDisplayString(_unref(estimatedNextTokenPriceImpactDifferenceFormattedPercentage)) + "% ", 3)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_unref(isSelling))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                block: "",
                color: "primary",
                size: "large",
                disabled: !_unref(isAllowSelling),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalData).confirm && _unref(modalData).confirm()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(
              _unref(isAllowSelling)
                ? _ctx.$t('common.allowUseOfToken')
                : _ctx.$t('common.useOfTokenAllowed')
            )
                  }, null, 8, _hoisted_17)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            block: "",
            color: "primary",
            size: "large",
            disabled: _unref(isSelling) && _unref(isAllowSelling),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalData).confirm && _unref(modalData).confirm()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('common.confirm'))
              }, null, 8, _hoisted_18)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            block: "",
            variant: "text",
            size: "small",
            color: "rgba(255, 255, 255, 0.5)",
            class: "text-uppercase",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(modalData).reject && _unref(modalData).reject()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('common.cancel'))
              }, null, 8, _hoisted_19)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})